import Head from 'next/head';

export const Meta: React.FC = () => {
  return (
    <Head>
      <link
        rel='apple-touch-icon'
        sizes='180x180'
        href='/favicon/apple-touch-icon.png'
      />
      <link
        rel='icon'
        type='image/png'
        sizes='32x32'
        href='/favicon/favicon-32x32.png'
      />
      <link
        rel='icon'
        type='image/png'
        sizes='16x16'
        href='/favicon/favicon-16x16.png'
      />
      <link rel='shortcut icon' href='/favicon/favicon.ico' />
      <link rel='alternate' type='application/rss+xml' href='/feed.xml' />
    </Head>
  );
};

export default Meta;
